import type { PickClientAppDataConfigProps } from '@ori/client-app-config';
import { ProductInfoDialogController } from '@ori/product-info-dialog';
import { Team, TestIdProvider } from '@ori/testid-generator';
import { type FC } from 'react';

import { APP_NAME } from './constants';

export type AppProps = PickClientAppDataConfigProps<
  'currentLanguage' | 'globalApiUrl' | 'graphqlUrl' | 'staticApiUrl' | 'tenant'
>;
export const App: FC<AppProps> = ({ currentLanguage, globalApiUrl = '', graphqlUrl, staticApiUrl = '', tenant }) => (
  <TestIdProvider
    team={Team.Presentation}
    project={APP_NAME}
  >
    <ProductInfoDialogController
      currentLanguage={currentLanguage}
      globalApiUrl={globalApiUrl}
      graphqlUrl={graphqlUrl}
      staticApiUrl={staticApiUrl}
      tenant={tenant}
    />
  </TestIdProvider>
);
